import { render, staticRenderFns } from "./ExamProfileSelect.vue?vue&type=template&id=8e2f4a50"
import script from "./ExamProfileSelect.vue?vue&type=script&lang=js"
export * from "./ExamProfileSelect.vue?vue&type=script&lang=js"
import style0 from "./ExamProfileSelect.vue?vue&type=style&index=0&id=8e2f4a50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports